var React = require('react');

function IconPlayHoverInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_43","data-name":"Group 43","transform":"translate(-670 -407)"},[React.createElement("path",{"id":"Polygon_1","data-name":"Polygon 1","d":"M11.143,1.429a1,1,0,0,1,1.715,0L23.091,18.486A1,1,0,0,1,22.234,20H1.766a1,1,0,0,1-.857-1.514Z","transform":"translate(695 410) rotate(90)","fill":"#68abd7","key":0}),React.createElement("rect",{"id":"Rectangle_28","data-name":"Rectangle 28","width":"30","height":"30","transform":"translate(670 407)","fill":"none","key":1})]));
}

IconPlayHoverInline.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = IconPlayHoverInline;

IconPlayHoverInline.default = IconPlayHoverInline;
